export default __webpack_public_path__ + "static/Milan-Laser-Hair-Removal-Announces-New-Chief-Development-Officer-f5ab8851101c78a99cd3c203a3d5d48c.pdf";